import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import DashboardComponent from './dashboard.component';
import Rx from 'rxjs/Rx';

let DashboardModule = angular
  .module('Dashboard', [
    uiRouter
  ])
  .component('dashboard', DashboardComponent)
  .filter('translate', () => {
    return (input, source) => {
      if (source.hasOwnProperty(input)) {
        return source[input];
      }
      return input;
    };
  })
  .filter('capitalize', () => {
    return input => {
      return input.split(' ').map(word => {
        return word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase();
      }).join(' ');
    };
  })
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('dashboard', {
      url: '/dashboard',
      data: {
        authRequired: true
      },
      views: {
        'menu': {
          component: 'menu',
        },
        'content': {
          component: 'dashboard'
        }
      },
      resolve: {
        closingHourObservable: (ContentService, ProfilePermissionsService, $q) => {
          return ProfilePermissionsService.hasPermission('view-closing-hour') ? 
          ContentService.getClosingHour() : 
          Rx.Observable.fromPromise( $q((resolve, z) => resolve(undefined)));
        }
      }
    });
  })
  .name;

export default DashboardModule;



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.module.js